/**
 * @param {Number} min
 * @param {Number} max
 * @param {Number} value
 * @returns {number}
 */
const smartPercentCalculator = (min, max, value) => {
    let percent = ((value - min) / (max - min)) * 100;
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(percent)) {
        percent = 0;
    }
    return percent;
};

export default smartPercentCalculator;



// WEBPACK FOOTER //
// ./src/helpers/smart-percent-calculator.js